import { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Picker from 'emoji-picker-react';
import Paper from '@mui/material/Paper';
import { standardString } from '../../../utils/utils';

import {
  Autocomplete,
  ClickAwayListener,
  Fab,
  FormControl,
  TextField,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Button,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from '@mui/material';
import { Box } from '@mui/system';
import { AttachFile, Cancel, EmojiEmotions } from '@mui/icons-material';
import propTypes from 'prop-types';
import { isEqual, lastIndexOf, toLower, uniq } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useFirebase } from 'react-redux-firebase';
const MySwal = withReactContent(Swal);
const projectId = process.env.REACT_APP_PROJECT_ID;
const useStyles = makeStyles((theme) => ({
  systemMessage: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    position: 'relative',
  },
  systemMessagesCheckboxesContainer: {
    marginTop: theme.spacing(2),
  },
  circularProgress: {
    marginRight: theme.spacing(2),
    verticalAlign: 'middle',
  },
  textField: {
    marginTop: theme.spacing(3),
  },
  textArea: {
    marginTop: theme.spacing(3),
    fontSize: 'inherit',
    font: 'inherit',
  },
  cancelButton: {
    marginLeft: '10px',
  },
  emojisButton: {
    width: 'fit-content',
    background: '#ffcc01',
    color: 'white',
    margin: '0 8px',
    height: '30px',
    padding: '0 8px',
    '&:hover': {
      backgroundColor: '#e0b402',
    },
  },
  openMessageButton: {
    height: '36px',
    marginRight: '10px',
    fontSize: '14px',
    padding: '0 16px',
    textTransform: 'uppercase',
    borderRadius: '8px',
  },
  sendButton: {
    position: 'relative',
    width: '40px',
    background: '#ffcc01',
    color: theme.palette.white.main,
    margin: '0 8px',
    height: '30px',
    padding: '0 8px',
    '&:hover': {
      backgroundColor: '#e0b402',
      '& svg': {
        transform: 'scale(1.3)',
      },
    },
    '& svg': {
      position: 'absolute',
      transition: 'all .3s',
    },
  },
}));

function Message(props) {
  const classes = useStyles();
  const { inputs, initialState, mode, index, type, onSuccess, onDanger } = props;
  const [tmpMessage, setTmpMessage] = useState({});
  const appDispatch = useDispatch();
  const organization = useSelector((state) => state.app.organization);
  const profile = useSelector((state) => state.firebase.profile);
  const isAdmin = profile?.claims?.includes('admin');
  const firebase = useFirebase();
  const ref = firebase.storage().ref();

  // use default values to avoid uncontrolled components

  const [openEmojis, setOpenEmojis] = useState(false);
  const [lastFocus, setLastFocus] = useState('');
  const inputFile = useRef(null);

  useEffect(() => {
    if (!isEqual(initialState, tmpMessage) && mode !== 'create') {
      setTmpMessage(initialState);
    }
  }, [initialState]);

  useEffect(() => {
    if (!isEqual(initialState, tmpMessage)) {
      setTmpMessage(initialState);
    }
  }, []);

  const onEmojiClick = (event, emojiObject) => {
    const key = lastFocus;
    setTmpMessage({
      ...tmpMessage,
      [key]: tmpMessage[key] ? tmpMessage[key] + emojiObject.emoji : emojiObject.emoji,
    });
  };

  const handleOpenMessage = (messageId) => {
    window.open(
      `https://console.firebase.google.com/u/0/project/${projectId}/firestore/databases/-default-/data/~2Fmessages~2F${messageId}`,
    );
  };

  const getInput = (input, index) => {
    switch (input.type) {
      case 'autocomplete':
        return (
          <Autocomplete
            key={`${input.propName}${index}`}
            size="small"
            freeSolo
            value={tmpMessage[input.propName] || ''}
            onChange={(e, value) => {
              setTmpMessage({
                ...tmpMessage,
                [input.propName]: value,
              });
            }}
            options={uniq(
              input.values
                .filter(
                  (e) =>
                    !tmpMessage[input.propName] ||
                    standardString(e).indexOf(standardString(tmpMessage[input.propName])) !== -1,
                )
                .slice(0, 5),
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                required
                label={input.label}
                name={input.propName}
                onChange={(e) => {
                  setTmpMessage({
                    ...tmpMessage,
                    [input.propName]: e.target.value,
                  });
                }}
                sx={{ mt: 2 }}
              />
            )}
          />
        );
      case 'textarea':
        return (
          <FormControl fullWidth>
            <TextField
              className={classes.textArea}
              placeholder={input.label}
              name={input.propName}
              onFocus={() => setLastFocus(input.propName)}
              multiline
              inputProps={{ className: classes.message }}
              value={tmpMessage[input.propName] || ''}
              onChange={(e) => {
                setTmpMessage({
                  ...tmpMessage,
                  [input.propName]: e.target.value,
                });
              }}
              rows={6}
              variant="outlined"
              spellCheck="false"
            />
          </FormControl>
        );
      case 'text':
      default:
        return (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <TextField
              required
              label={input.label}
              name={input.propName}
              onFocus={() => setLastFocus(input.propName)}
              value={tmpMessage[input.propName] || ''}
              onChange={(e) => {
                setTmpMessage({
                  ...tmpMessage,
                  [input.propName]: e.target.value,
                });
              }}
              variant="outlined"
              spellCheck="false"
            />
          </FormControl>
        );
    }
  };

  const handleSuccess = (e) => {
    e && e.preventDefault();

    if (tmpMessage.stopBot) {
      if (!tmpMessage.message?.trim() && !tmpMessage.preMessage?.trim()) {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage:
              'Si la opción "Frenar bot" está habilitado, es obligatorio completar el "mensaje".',
            snackbarSeverity: 'error',
          },
        });
        return;
      }
    }

    onSuccess(tmpMessage, mode, index, type);
  };

  const handleDanger = async (e) => {
    e && e.preventDefault();
    onDanger(tmpMessage);
  };

  const handleChangeFile = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      if (!['pdf', 'png', 'jpg', 'jpeg'].find((e) => toLower(file.type).indexOf(e) !== -1)) {
        return appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: `Los tipos de archivos soportados son: .pdf, .jpeg, .png, .jpg`,
            snackbarSeverity: 'error',
          },
        });
      }

      if (file.size / 1000 > 64) {
        MySwal.fire({
          text: 'La imagen supera 64KB. Se le cobraras gastos adicionales. ¿Esta seguro que desea continuar?',
          showConfirmButton: true,
          showDenyButton: true,
          confirmButtonText: 'SI',
          denyButtonText: 'NO',
          icon: 'info',
        }).then((result) => {
          if (result.isConfirmed) {
            sendImage(file);
          }
        });
      } else {
        sendImage(file);
      }
    }
  };

  const sendImage = (file) => {
    if (file) {
      if (tmpMessage && tmpMessage.fileURL) {
        return MySwal.fire({
          text: 'Debe eliminar el archivo anterior previamente.',
          icon: 'info',
        });
      }
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: true, priority: 1 },
      });
      const isPDF = toLower(file.type).indexOf('pdf') !== -1;
      const random = Math.floor(Math.random() * 10000);
      const route = `system messages/${organization.id}/${random}-${file.name}`;
      ref
        .child(route)
        .put(file)
        .then(() => {
          ref
            .child(route)
            .getDownloadURL()
            .then((fileURL) => {
              onSuccess({ ...tmpMessage, fileURL: fileURL, isPDF }, mode, index, type);
            })
            .finally(() => {
              appDispatch({
                type: actions.changeLoading,
                loading: { loading: false, priority: 1 },
              });
            });
        })
        .catch(() => {
          appDispatch({
            type: actions.changeLoading,
            loading: { loading: false, priority: 1 },
          });
        });
    }
  };

  const handleDeleteFile = () => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    const lastIndex = lastIndexOf(tmpMessage.fileURL.split(''), '/');
    let urlToRemove = tmpMessage.fileURL.slice(lastIndex + 1, tmpMessage.fileURL.indexOf('?'));
    urlToRemove = decodeURIComponent(urlToRemove);
    var desertRef = ref.child(urlToRemove);
    desertRef
      .delete()
      .then(() => {
        handleSuccess();
        onSuccess({ ...tmpMessage, fileURL: null }, mode, index, type);
      })
      .catch(() => {})
      .finally(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };

  return (
    <Paper className={classes.systemMessage} elevation={3}>
      {openEmojis && (
        <ClickAwayListener
          onClickAway={(event) => {
            setOpenEmojis(false);
          }}
        >
          <Box position="absolute" zIndex={10} right={72}>
            <Picker onEmojiClick={onEmojiClick} />
          </Box>
        </ClickAwayListener>
      )}
      <form>
        <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
          {isAdmin && initialState?.id && (
            <Button
              variant="contained"
              color="primary"
              className={classes.openMessageButton}
              onClick={() => handleOpenMessage(initialState?.id)}
            >
              Abrir Mensaje
            </Button>
          )}
          <Fab className={classes.emojisButton} onClick={() => setOpenEmojis(!openEmojis)}>
            <EmojiEmotions />
          </Fab>
        </Box>

        {inputs
          .filter(
            (input) =>
              input.type !== 'file' &&
              input.type !== 'select' &&
              input.type !== 'checkbox' &&
              input.type !== 'button',
          )
          .map((input) => getInput(input, index))}

        <Box maxWidth="fit-content" maxHeight="250px" position="relative" my={2}>
          <Box
            width="100%"
            height="100%"
            position="absolute"
            sx={{
              opacity: 0,
              transition: 'all .3s',
              background: 'rgba(0,0,0,.5)',
              '&:hover': {
                opacity: 1,
              },
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={handleDeleteFile}
          >
            <Cancel sx={{ color: 'white !important', fontSize: 46 }} />
          </Box>
          {tmpMessage && tmpMessage.fileURL && !tmpMessage.isPDF && (
            <img src={tmpMessage.fileURL} style={{ maxWidth: '100%', maxHeight: '250px' }} />
          )}
        </Box>
        <FormGroup
          row
          sx={{
            mt: 2,
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
          }}
        >
          <Box
            item
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'flex-start',
              alignItems: 'center',
              width: '100%',
              flexWrap: 'wrap',
            }}
          >
            {inputs
              .filter((input) => input.type === 'checkbox')
              .map((input) => {
                if (input.propName === 'stopBot' && tmpMessage.showFreeApps) {
                  return null;
                }
                return (
                  <FormControlLabel
                    key={`${input.propName}${index}`}
                    control={
                      <Checkbox
                        checked={!!tmpMessage[input.propName]}
                        name={input.propName}
                        onChange={(e) => {
                          const isChecked = e.target.checked;

                          if (input.propName === 'showFreeApps') {
                            const updatedMessage = {
                              ...tmpMessage,
                              showFreeApps: isChecked,
                              stopBot: isChecked ? false : tmpMessage.stopBot || false,
                              chatStateAfterTurn: tmpMessage?.chatStateAfterTurn || 3,
                            };

                            setTmpMessage(updatedMessage);
                          } else {
                            const updatedMessage = {
                              ...tmpMessage,
                              [input.propName]: isChecked,
                            };
                            setTmpMessage(updatedMessage);
                          }
                        }}
                      />
                    }
                    label={input.label}
                  />
                );
              })}
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              width: '100%',
            }}
          >
            <Box
              item
              sx={{
                alignItems: 'center',
              }}
            >
              {inputs
                .filter((input) => input.type === 'file')
                .map((input) => (
                  <Grid
                    key={`${input.propName}${index}`}
                    id="popup-btn"
                    sx={{
                      position: 'relative',
                      height: '100%',
                      mr: 2,
                    }}
                  >
                    <Fab className={classes.sendButton} onClick={() => inputFile.current.click()}>
                      <AttachFile />
                    </Fab>
                    <input
                      onChange={handleChangeFile}
                      type="file"
                      ref={inputFile}
                      style={{ display: 'none' }}
                    />
                  </Grid>
                ))}
            </Box>
            <Box
              item
              sx={{
                flexGrow: 1,
              }}
            >
              {inputs
                .filter((input) => input.type === 'select')
                .filter((input) => {
                  // Si es chatStateAfterTurn, solo se muestra si showFreeApps es verdadero
                  if (input.propName === 'chatStateAfterTurn') {
                    return tmpMessage.showFreeApps;
                  }
                  return true;
                })
                .map((input) => (
                  <FormControl key={`${input.propName}${index}`} sx={{ mr: 2, minWidth: '200px' }}>
                    <InputLabel id="select">{input.label}</InputLabel>
                    <Select
                      labelId="select"
                      id="select"
                      value={
                        tmpMessage[input.propName] === 0 || tmpMessage[input.propName]
                          ? tmpMessage[input.propName]
                          : -1
                      }
                      label={input.label}
                      onChange={(e) => {
                        setTmpMessage({
                          ...tmpMessage,
                          [input.propName]: e.target.value,
                        });
                      }}
                    >
                      {input.propName === 'chatStateAfterTurn' ? (
                        input &&
                        input.values &&
                        input.values
                          .filter((e) => e.value !== 3)
                          .map((e) => (
                            <MenuItem key={e.value} value={e.value}>
                              {e.label}
                            </MenuItem>
                          ))
                      ) : input.propName === 'actionType' ? null : (
                        <MenuItem key={-1} value={-1}>
                          No cambiar
                        </MenuItem>
                      )}
                      {input &&
                        input.values &&
                        input.values.map((e) => (
                          <MenuItem key={e.value} value={e.value}>
                            {e.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                ))}
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginLeft: 'auto',
              }}
            >
              {inputs
                .filter((input) => input.type === 'button')
                .map((input) => {
                  if (isEqual(tmpMessage, initialState) && input.isSuccess) return null;
                  return (
                    <Button
                      key={`${input.propName}${index}`}
                      variant="contained"
                      color={input.isSuccess ? 'primary' : 'secondary'}
                      className={input.isSuccess ? classes.cancelButton : ''}
                      sx={{ ml: index !== 0 ? 2 : 0, height: 'fit-content' }}
                      onClick={input.isSuccess ? handleSuccess : handleDanger}
                    >
                      {input.label}
                    </Button>
                  );
                })}
            </Box>
          </Box>
        </FormGroup>
      </form>
    </Paper>
  );
}

const Props = {
  inputs: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string,
      propName: propTypes.string,
      type: propTypes.string,
      values: propTypes.array,
    }),
  ),
  mode: propTypes.string,
  index: propTypes.number,
  type: propTypes.string,
  onSuccess: propTypes.func,
  onDanger: propTypes.func,
  initialState: propTypes.object,
};

Message.propTypes = Props;

export default Message;
